import { PassesList } from 'booking/components';
import { useDocumentTitle } from 'usehooks-ts';

export function Passes(): JSX.Element {
  useDocumentTitle('DRYCUT - DRYPASS');

  return <PassesList />;
}
